import { useCallback, type ChangeEvent } from 'react';
import { Input, type InputProps } from '@chakra-ui/react';

import {
  formatLicenseNumberForProvince,
  getLicenseFormatInfo,
  getMaxLengthForProvince,
} from 'utils/licenseNumber';

export interface LicenseNumberInputProps extends Omit<
  InputProps,
  'value' | 'onChange'
> {
  value: string;
  provinceId: number;
  onChange: (value: string) => void;
}

const LicenseNumberInput = ({
  value,
  provinceId,
  onChange,
  ...inputProps
}: LicenseNumberInputProps) => {
  const formatInfo = getLicenseFormatInfo(provinceId);
  const maxLength = getMaxLengthForProvince(provinceId);

  const handleChange = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      const rawValue = e.target.value;
      const formatted = formatLicenseNumberForProvince(rawValue, provinceId);
      onChange(formatted);
    },
    [provinceId, onChange],
  );

  return (
    <Input
      {...inputProps}
      value={value}
      onChange={handleChange}
      maxLength={maxLength}
      placeholder={formatInfo?.example || 'License number'}
      autoComplete="off"
      spellCheck={false}
    />
  );
};

export default LicenseNumberInput;
